window.previewImage = function (input, previewId) {
    const preview = document.getElementById(previewId);
    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = function (e) {
        // Alleen containers die zelf verborgen starten hoeven zichtbaar gemaakt te worden.
        if (preview.style.display === 'none') {
            preview.style.display = 'block';
        }

        let image = preview.querySelector('img');

        if (!image) {
            preview.innerHTML = '';
            image = document.createElement('img');
            preview.appendChild(image);
        }

        image.src = e.target.result;
    };

    if (file) {
        reader.readAsDataURL(file);
    }
}
